import { render } from "./Footer.vue?vue&type=template&id=1bb9a046"
const script = {}
script.render = render

export default script